import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Tokens} from '../../entities/authentication/tokens.entity';
import {environment} from '../../../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService
{
  public constructor(
    private readonly http: HttpClient,
  ) {
  }

  public register(
    email: string,
    password: string,
    role: string,
    timezone: string,
    firstname: string|null = null,
    lastname: string|null = null,
  ): Observable<Tokens> {
    return this.http.post<Tokens>(`${environment.apiUrl}/register`, {
      email,
      password,
      role,
      timezone,
      firstname,
      lastname
    });
  }

}
